import { render, staticRenderFns } from "./DailyBonusItem.vue?vue&type=template&id=931df8e6&scoped=true"
import script from "./DailyBonusItem.vue?vue&type=script&lang=js"
export * from "./DailyBonusItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931df8e6",
  null
  
)

export default component.exports